import React, { useState } from 'react';
import './GameMenu.css';

function GameMenu({ token, studentId, onLogout }) {
  const API_URL = 'https://mylearningacademy.org/api';
  const [questPoints, setQuestPoints] = useState(0);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('studentId');
    onLogout();
  };

  const handleLogin = () => {
    window.location.href = '/careerquest/logincareer.html';
  };

  const handleLearnNewSkill = () => {
    fetch(API_URL + '/game/learn-skill', {
      method: 'POST',
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ studentId })
    })
      .then(res => res.json())
      .then(data => console.log('Learn skill:', data))
      .catch(err => console.error('Error:', err));
  };

  const handleCreateAvatar = () => {
    fetch(API_URL + '/game/create-avatar', {
      method: 'POST',
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ studentId })
    })
      .then(res => res.json())
      .then(data => console.log('Avatar created:', data))
      .catch(err => console.error('Error:', err));
  };

  const handleContinueGame = () => {
    fetch(API_URL + '/game/continue', {
      method: 'GET',
      headers: { 'Authorization': 'Bearer ' + token }
    })
      .then(res => res.json())
      .then(data => console.log('Continue game:', data))
      .catch(err => console.error('Error:', err));
  };

  const handlePractice = () => {
    fetch(API_URL + '/game/practice', {
      method: 'GET',
      headers: { 'Authorization': 'Bearer ' + token }
    })
      .then(res => res.json())
      .then(data => console.log('Practice:', data))
      .catch(err => console.error('Error:', err));
  };

  const handleCheckPoints = () => {
    if (!token) {
      alert('Please log in first');
      return;
    }
    fetch(API_URL + '/quest-points/balance', {
      headers: { 'Authorization': 'Bearer ' + token }
    })
      .then(res => res.json())
      .then(data => {
        setQuestPoints(data.totalPoints);
        alert('Your Points: ' + data.totalPoints);
      })
      .catch(err => alert('Error: ' + err));
  };

  const handleSpendPoints = () => {
    fetch(API_URL + '/game/spend-points', {
      method: 'POST',
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ studentId })
    })
      .then(res => res.json())
      .then(data => console.log('Spend points:', data))
      .catch(err => console.error('Error:', err));
  };

  const handleGetCertificate = () => {
    fetch(API_URL + '/game/certificate', {
      method: 'GET',
      headers: { 'Authorization': 'Bearer ' + token }
    })
      .then(res => res.json())
      .then(data => console.log('Certificate:', data))
      .catch(err => console.error('Error:', err));
  };

  const handleChooseOccupation = () => {
    fetch(API_URL + '/game/choose-occupation', {
      method: 'POST',
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ studentId })
    })
      .then(res => res.json())
      .then(data => console.log('Occupation chosen:', data))
      .catch(err => console.error('Error:', err));
  };

  const handleSchoolLogin = () => {
    window.location.href = '/careerquest/schoollogin.html';
  };

  const handleParentLogin = () => {
    window.location.href = '/careerquest/parentlogin.html';
  };

  const handleChangeGrade = () => {
    fetch(API_URL + '/student/change-grade', {
      method: 'POST',
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ studentId })
    })
      .then(res => res.json())
      .then(data => console.log('Grade changed:', data))
      .catch(err => console.error('Error:', err));
  };

  const handleChangeProfile = () => {
    fetch(API_URL + '/student/change-profile', {
      method: 'POST',
      headers: { 
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ studentId })
    })
      .then(res => res.json())
      .then(data => console.log('Profile changed:', data))
      .catch(err => console.error('Error:', err));
  };

  const handleGetHelp = () => {
    window.location.href = '/careerquest/help.html';
  };

  return (
    <div className="game-menu-container">
      <div className="game-menu-header">
        <h1>Game Menu</h1>
        <p>Get ready to prepare for REAL LIFE!</p>
      </div>

      <div className="game-menu-buttons">
        <div className="button-row">
          <button className="game-button" onClick={handleLogin}>Login</button>
          <button className="game-button" onClick={handleLogout}>Logout</button>
          <button className="game-button" onClick={handleLearnNewSkill}>Learn New Skill</button>
          <button className="game-button" onClick={handleCreateAvatar}>Create Avatar</button>
          <button className="game-button" onClick={handleContinueGame}>Continue Game</button>
        </div>

        <div className="button-row">
          <button className="game-button" onClick={handlePractice}>Practice</button>
          <button className="game-button" onClick={handleCheckPoints}>Check Points</button>
          <button className="game-button" onClick={handleSpendPoints}>Spend Points</button>
          <button className="game-button" onClick={handleGetCertificate}>Get Certificate</button>
          <button className="game-button" onClick={handleChooseOccupation}>Choose Occupation</button>
        </div>

        <div className="button-row">
          <button className="game-button" onClick={handleSchoolLogin}>School Log In</button>
          <button className="game-button" onClick={handleParentLogin}>Parent Login</button>
          <button className="game-button" onClick={handleChangeGrade}>Change Grade</button>
          <button className="game-button" onClick={handleChangeProfile}>Change Profile</button>
          <button className="game-button" onClick={handleGetHelp}>Get Help</button>
        </div>
      </div>

      <div className="game-menu-login-section">
        <a href="/careerquest/gameapp/" className="login-link">
          Login to the game
        </a>
      </div>
    </div>
  );
}

export default GameMenu;
